function axisTitle(name, title) { //__execs__의 axis만 변화
  let splited = name.split('.');
  let target = splited[0]; 
  let field = splited.length > 2 ? splited.slice(1).join('.') : splited[1];
  let titles = this.axisTitles();
  let exist = -1;
  let shape;
  if (target.includes('-')) {
    let splited = target.split('-');
    target = splited[0];
    shape = splited.length > 2 ? splited.slice(1).join('-') : splited[1];
  }
  //TODO: y-line이나 y-bar 인 경우 고려
  for (let i= 0; i < titles.length; i++) {
    let t = titles[i];
    if (t.field === field && t.target === target && t.shape === shape) {
      exist = i;
      break;
    }
  }
  if (title) { //title이 있는 경우는 넣고 없는 경우는  뺀다.
    let result = {target, field, title, shape};
    if (exist >= 0) titles.splice(exist, 1, result);
    else titles.push(result); //axisDefault에서 axisTitles를 뒤져보고 결정
  } else {
    titles.splice(exist, 1);
  }
  return this;
}

export default axisTitle;


// WEBPACK FOOTER //
// ./layouts/rectLinear/axisTitle.js